<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else id="">
    <div class="">
      <div
        data-html2canvas-ignore="true"
        class="customdim"
        v-show="loader || loaderTableStatus"
      >
        <!-- <div class="spinner-border" role="status"><span class="sr-only">{{ translatedLang["Loading"][selectedLanguage.key] }}...</span></div> -->
        <Loader />
      </div>

      <div class="sellerRankTable">
        <SellerRankWiseTable />
      </div>

      <div
        class="row datepickerwrap card"
        style="z-index: 998 !important"
        v-if="viewlinkesDropdown.length"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex" style="width: 70%">
            <div class="mr-2">
              <div
                style="
                  font-size: 13px;
                  font-weight: 400;
                  color: #1e1e1e;
                  margin-bottom: 0.29rem;
                  margin-left: 5px;
                "
              >
                {{ translatedLang["Date Range"][selectedLanguage.key] }}
              </div>
              <date-range-picker
                v-model="dateRange"
                opens="right"
                :autoApply="true"
                :locale-data="{ format: 'dd mmm yyyy' }"
                :min-date="minDate"
                :max-date="maxDate"
                @update="dateChange"
              >
              </date-range-picker>
            </div>
            <div class="customMultiselectCommon mr-2" style="width: 155px">
              <div
                style="
                  font-size: 13px;
                  font-weight: 400;
                  color: #1e1e1e;
                  margin-bottom: 0.29rem;
                  margin-left: 5px;
                "
              >
                {{ translatedLang["Brand"][selectedLanguage.key] }}
              </div>
              <!-- <select class="form-control text-capitalize" style="height:34px" v-model="selectedWebsite">
                <option value="" style="height:30px" class="text-capitalize">Select Brand</option>
                <option style="height:30px" v-for="(d, i) in viewWebsitesDropdown" :key="i" :value="d.value"
                  class="text-capitalize">
                  {{ d.label }}</option>
              </select> -->
              <multiselect
                v-model="selectedWebsite"
                :options="[
                  {
                    label: '',
                    value: translatedLang['Select Brand'][selectedLanguage.key],
                  },
                  ...viewWebsitesDropdown,
                ]"
                label="value"
                track-by="label"
                :multiple="false"
                :searchable="false"
                placeholder="Select Brand"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="text-capitalize"
              >
                <template #option="{ option }">
                  <div class="custom-option text-capitalize">
                    <span>{{ option.value }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="customMultiselectCommon mr-2" style="width: 300px">
              <div
                style="
                  font-size: 13px;
                  font-weight: 400;
                  color: #1e1e1e;
                  margin-bottom: 0.29rem;
                  margin-left: 5px;
                "
              >
                {{ translatedLang["Product"][selectedLanguage.key] }}
              </div>
              <!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedlink"
                @click="submitDetails">
                <option value="" style="height:30px" class="text-capitalize">Select Name</option>
                <option style="height:30px" v-for="(d, i) in viewlinkesDropdown" :key="i" :value="d.link"
                  class="text-capitalize">{{ d.value }}
                </option>
              </select> -->
              <multiselect
                v-model="selectedlink"
                :options="viewlinkesDropdown"
                label="value"
                track-by="link"
                :multiple="false"
                :searchable="false"
                placeholder="Select Product"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="text-capitalize"
              >
                <template #option="{ option }">
                  <div
                    class="custom-option text-capitalize"
                    :title="option.value"
                  >
                    <span>{{ option.value }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div style="margin-top: 1.4rem">
              <button
                class="btn primarycolor"
                type="button"
                style="height: 35px; padding: 3px 14px 4px"
                @click="submitDetails"
              >
                <span style="font-size: 14px">
                  {{
                    translatedLang["Apply Filters"][selectedLanguage.key]
                  }}</span
                >
              </button>
            </div>
          </div>
          <!-- <div class="lastUpdated ml-2" v-if="lastUpdated">
            Last Updated: {{ lastUpdated }}
          </div> -->
        </div>
      </div>

      <div class="mx-2 card">
        <div class="mycols">
          <div class="space-between capitalize">
            <a
              v-if="sellerGraph.data.length"
              :href="selectedlink.link"
              target="_blanck"
              class="graphHeading"
              >{{
                viewlinkesDropdown[
                  viewlinkesDropdown.findIndex(
                    (obj) => obj.link == selectedlink.link
                  )
                ] &&
                viewlinkesDropdown[
                  viewlinkesDropdown.findIndex(
                    (obj) => obj.link == selectedlink.link
                  )
                ].value
              }}</a
            >
            <div
              class="customMultiselectCommon mb-1 ml-3"
              v-if="sellerGraph.data.length"
              style="width: 244px"
            >
              <div style="font-size: 13px" class="mb-1 ml-1">Category</div>
              <!-- <select class="form-control text-capitalize" style="height:34px; width:140px;"
                v-model="sellerGraph.selectedCategory" @change="processSellerGraphData">
                <option style="height:30px" v-for="d in sellerGraph.CategoryList" :key="d" :value="d"
                  class="text-capitalize">{{ d }}</option>
              </select> -->
              <multiselect
                @input="processSellerGraphData"
                v-model="sellerGraph.selectedCategory"
                :options="sellerGraph.CategoryList"
                :multiple="false"
                :searchable="false"
                placeholder="Select Category"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="text-capitalize"
              >
                <template #option="{ option }">
                  <div class="custom-option text-capitalize">
                    <span>{{ option }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="" ref="lineChartContainer">
            <div
              style="margin-top: 20px"
              v-if="sellerGraph.data.length && sellerGraphLineShowData"
            >
              <highcharts :options="lineChartData" ref="chart"></highcharts>
            </div>
            <div
              v-else-if="!sellerGraphLineShowData && loader"
              class="onLoadingData mt-1"
            >
              {{ translatedLang["Loading"][selectedLanguage.key] }}...
            </div>
            <div
              v-else
              class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
            >
              {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="!rank">
        <keyword-tracker-table-data />
      </div> -->
      <div v-if="bestSellerSections.seller_rank_table">
        <div
          class="row datepickerwrap card"
          style=""
          v-if="viewBestSellersRankFiltereData"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center" style="width: 80%">
              <div class="customSelect mr-2">
                <div
                  style="font-size: 13px; margin-left: 5px"
                  class="mb-1 mt-2"
                >
                  {{ translatedLang["Date"][selectedLanguage.key] }}
                </div>
                <date-range-picker
                  style="width: 150px"
                  v-model="dateRangeBestSeller"
                  :show-dropdowns="true"
                  opens="right"
                  :autoApply="true"
                  :locale-data="{ format: 'dd mmm yyyy' }"
                  :min-date="bestSellerMinDate"
                  :max-date="bestSellerMaxDate"
                  :single-date-picker="true"
                  :ranges="false"
                >
                </date-range-picker>
              </div>
              <div class="customMultiselectCommon mt-1 mr-2">
                <div style="font-size: 13px; margin-left: 5px" class="mb-1">
                  {{ translatedLang["Platform"][selectedLanguage.key] }}
                </div>
                <!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedPlatform"
                  @change="filterCategoryData(true)">
                  <option style="height:30px" v-for="(d, i) in viewPlatformList" :key="i" :value="d"
                    class="text-capitalize">
                    {{ d }}</option>
                </select> -->
                <multiselect
                  :custom-label="updateSelectedLabels"
                  track-by="key"
                  label="value"
                  @input="filterCategoryData(true)"
                  v-model="selectedPlatform"
                  :options="viewPlatformList"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select Platform"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="text-capitalize"
                >
                  <template #option="{ option }">
                    <div class="custom-option text-capitalize">
                      <span>{{ option.value.replace("_", " ") }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="customMultiselectCommon mt-1 mr-2">
                <div style="font-size: 13px; margin-left: 5px" class="mb-1">
                  {{ translatedLang["Category"][selectedLanguage.key] }}
                </div>
                <!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedCategory"
                  @change="filterSubCategoryData(true)">
                  <option style="height:30px" v-for="(d, i) in viewCategoryList" :key="i" :value="d"
                    class="text-capitalize">{{ d }}
                  </option>
                </select> -->
                <multiselect
                  :custom-label="updateSelectedLabels"
                  track-by="key"
                  label="value"
                  @input="filterSubCategoryData(true)"
                  v-model="selectedCategory"
                  :options="viewCategoryList"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select Category"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="text-capitalize"
                >
                  <template #option="{ option }">
                    <div class="custom-option text-capitalize">
                      <span>{{ option.value.replace("_", " ") }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div
                class="customMultiselectCommon mt-1 mr-2"
                style="width: 200px"
              >
                <div style="font-size: 13px; margin-left: 5px" class="mb-1">
                  {{ translatedLang["Sub Category"][selectedLanguage.key] }}
                </div>
                <!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedSubCategory"
                  @change="filterPriceBandData(true)">
                  <option style="height:30px" v-for="(d, i) in viewSubCategoryList" :key="i" :value="d"
                    class="text-capitalize">{{
                      d.replace('_', ' ') }}
                  </option>
                </select> -->
                <multiselect
                  :custom-label="updateSelectedLabels"
                  track-by="key"
                  label="value"
                  @input="filterPriceBandData(true)"
                  v-model="selectedSubCategory"
                  :options="viewSubCategoryList"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select Sub Category"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="text-capitalize"
                >
                  <template #option="{ option }">
                    <div class="custom-option text-capitalize">
                      <span>{{ option.value.replace("_", " ") }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div
                class="customMultiselectCommon mt-1 mr-2"
                style="width: 180px"
              >
                <div style="font-size: 13px; margin-left: 5px" class="mb-1">
                  {{ translatedLang["Price Range"][selectedLanguage.key] }}
                </div>
                <!-- <select class="form-control text-capitalize" style="height:34px" v-model="selectedPriceBand">
                  <option value="" style="height:30px">All</option>
                  <option style="height:30px" v-for="(d, i) in viewPriceBandList" :key="i" :value="d"
                    class="text-capitalize">{{ d }}
                  </option>
                </select> -->
                <multiselect
                  v-model="selectedPriceBand"
                  label="label"
                  track-by="value"
                  :options="[
                    { label: 'All', value: '' },
                    ...viewPriceBandList.map((priceRange) => ({
                      label: priceRange,
                      value: priceRange,
                    })),
                  ]"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select Price Range"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="text-capitalize"
                >
                  <template #option="{ option }">
                    <div class="custom-option text-capitalize">
                      <span>{{ option.label }}</span>
                    </div>
                  </template>
                  <!-- <template #single-label="{ option }">
                    <span>{{ option === '' ? 'All' : option }}</span>
                  </template> -->
                </multiselect>
              </div>
              <button
                class="btn primarycolor mt-4"
                type="button"
                style="height: 35px; padding: 3px 14px 4px"
                @click="getBestSellerRankData(true)"
              >
                <span style="font-size: 14px">
                  {{
                    translatedLang["Apply Filters"][selectedLanguage.key]
                  }}</span
                >
              </button>
            </div>
            <div class="text-right">
              <div
                style="font-size: 12px !important"
                v-if="storeBestSellerTableStatus"
                :class="[`mb-2 text-capitalize badge ${getClassStatusWise}`]"
              >
                {{ storeBestSellerTableStatus }}
              </div>
              <div
                class="lastUpdated ml-2"
                :class="[!storeBestSellerTableStatus && 'mt-4']"
              >
                {{ translatedLang["Last Updated"][selectedLanguage.key] }}:
                {{ bestSellerLastUpdatedDataDate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="card mx-2"
          v-if="
            viewBestSellersRankTableBodyData.length &&
            bestSellerMainTableShowData
          "
        >
          <table id="bestSellerRankTable">
            <thead>
              <tr>
                <th
                  v-for="head of viewBestSellersRankTableHeaderData"
                  :key="head.key"
                  class="py-2"
                  :class="{
                    'product-name-column': head.key === 'product_name',
                    'brand-width-column': head.key === 'brand_name',
                    'seller-width-column': head.key === 'seller',
                    'rank-width-column': head.key === 'rank',
                    'rating-width-column': head.key === 'rating',
                    'originalPrice-width-column': head.key === 'original_price',
                    'review-width-column': head.key === 'review',
                    'discountPrice-width-column': head.key === 'price',
                  }"
                >
                  {{ head.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="td of viewBestSellersRankTableBodyData"
                :key="td + rank"
              >
                <td
                  v-for="head of viewBestSellersRankTableHeaderData"
                  :key="head.key"
                  :class="{
                    'product-name-column': head.key === 'product_name',
                    'brand-width-column': head.key === 'brand_name',
                    'seller-width-column': head.key === 'seller',
                    'rank-width-column': head.key === 'rank',
                  }"
                >
                  <div v-if="head.key == 'product_name'">
                    <a
                      :href="td.product_link"
                      target="_blank"
                      class="text-capitalize"
                      >{{ td[head.key] }}</a
                    >
                  </div>
                  <div v-else-if="head.key == 'brand_name'">
                    <div class="text-capitalize">{{ td[head.key] }}</div>
                  </div>
                  <div
                    v-else-if="head.key == 'seller'"
                    :class="{ 'text-danger': td[head.key] === 'Unavailable' }"
                  >
                    <div class="text-capitalize">{{ td[head.key] }}</div>
                  </div>
                  <div v-else>{{ td[head.key] }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else-if="!bestSellerMainTableShowData && loader"
          class="row datepickerwrap card"
        >
          <div class="onLoadingData m-0 p-0">
            {{ translatedLang["Loading"][selectedLanguage.key] }}...
          </div>
        </div>
        <div v-else class="mx-2 card">
          <div
            class="text-danger d-flex justify-content-center border border-danger rounded mt-0 p-0 noData"
          >
            {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import KeywordTrackerTableData from "./KeywordTrackerTableData.vue";
// import NewRankTable from './NewRankTable.vue';
import Multiselect from "vue-multiselect";
import SellerRankWiseTable from "./SellerRankWiseTable.vue";
// import Loader from '../Components/Loader.vue';
import Loader from "../Components/Loader.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "KeywordTracker",
  components: {
    Datepicker,
    KeywordTrackerTableData,
    SellerRankWiseTable,
    Loader,
    Multiselect,
  },

  data: function () {
    return {
      lineChartData: {},
      loader: true,
      loaderLinePlot: true,
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      selectedWebsite: { label: "", value: "Select Brand" },
      selectedlink: { link: "", value: "Select Name" },
      viewWebsitesDropdown: [],
      viewlinkesDropdown: [],
      lastUpdated: "",
      sellerGraph: {
        data: [],
        CategoryList: [],
        selectedCategory: "",
      },
      rank: JSON.parse(localStorage.reviewUserData).data.is_rank,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      // best seller rank table variable
      viewBestSellersRankTableBodyData: "",
      viewBestSellersRankTableHeaderData: "",
      viewBestSellersRankFiltereData: "",
      viewBestSellersRankFiltereDataForPrice: "",
      viewPlatformList: [],
      viewCategoryList: [],
      viewSubCategoryList: [],
      viewPriceBandList: [],
      selectedPlatform: "",
      selectedCategory: "",
      selectedSubCategory: "",
      selectedPriceBand: { label: "All", value: "" },
      dateRangeBestSeller: {
        startDate: moment("08-31-2024").format("YYYY-MM-DD"),
        endDate: moment("08-31-2024").format("YYYY-MM-DD"),
      },
      bestSellerMinDate: "",
      bestSellerMaxDate: "",
      bestSellerLastUpdatedDataDate: "",
      bestSellerSections: {
        seller_rank_table: true,
      },

      storeAllDataForBestSellerTableStatus: {},
      loaderTableStatus: false,
      storeBestSellerTableStatus: "",

      sellerGraphLineShowData: false,
      bestSellerMainTableShowData: false,
      showNoDataImgForUser: false,
    };
  },
  created() {
    if (JSON.parse(localStorage.reviewUserData).data.best_seller_sections) {
      this.bestSellerSections = JSON.parse(
        localStorage.reviewUserData
      ).data.best_seller_sections;
    }
  },
  mounted() {
    // this.destroyAllTables()
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
    // this.dataAPIs()
    this.$nextTick(() => {
      this.resizeObserver = new ResizeObserver(() => {
        this.resizeChart();
      });
      if (this.$refs.lineChartContainer) {
        this.resizeObserver.observe(this.$refs.lineChartContainer);
      }
    });
  },

  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    getClassStatusWise() {
      return {
        completed: "badge-success",
        failed: "badge-danger",
        scheduled: "badge-secondary",
        running: "badge-light",
      }[this.storeBestSellerTableStatus];
    },
  },

  watch: {
    "selectedSubCategory.key": function () {
      if (Object.keys(this.storeAllDataForBestSellerTableStatus).length) {
        this.storeBestSellerTableStatus =
          this.storeAllDataForBestSellerTableStatus[
            this.selectedPlatform.key.toLowerCase().replace(" ", "_")
          ][this.selectedSubCategory.key.replace("-", "_")];
      } else {
        this.storeBestSellerTableStatus = "";
      }
    },
    dateRangeBestSeller: {
      handler() {
        this.getAllStatusByApi();
      },
      deep: true,
    },
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    getLastUpdatedDates() {
      this.loader0 = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.best_sellers_ranking) {
            this.showNoDataImgForUser = false;
            localStorage.best_sellers_ranking_last_update = JSON.stringify(
              response.body.data.best_sellers_ranking
            );
          }
          if (response.body.data.best_sellers_ranking == false) {
            this.showNoDataImgForUser = true;
          }
          this.loader0 = false;
          this.dataAPIs();
        },
        (err) => {
          this.loader0 = false;
          this.dataAPIs();
        }
      );
    },
    dataAPIs() {
      this.formatDates();
      if (this.bestSellerSections.seller_rank_table)
        this.getBestSellerRankData(false);
      else
        this.getWebsiteandKeywordDropdownData();

    },

    resizeChart() {
      if (this.$refs.chart.chart) {
        this.$refs.chart.chart.reflow();
      }
    },

    formatDates() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
    },
    dateChange() {
      this.formatDates();
    },

    updateSelectedLabels(option) {
      return option.value.replace("_", " ");
    },

    getWebsiteandKeywordDropdownData() {
      let self = this;
      self.loader = true;
      let payload = {
        // client: this.client
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/websites/amazon_seller_brand_link_and_name";
      self.$http
        .post(url, payload)
        .then((response) => {
          if (Object.keys(response.data.data.data).length) {
            this.selectedWebsite = response.data.data.data.data[0];
            this.selectedlink = response.data.data.data.link[0];
            self.viewWebsitesDropdown = response.data.data.data.data;
            self.viewlinkesDropdown = response.data.data.data.link;
            self.loader = false;
            this.submitDetails();
          } else {
            self.loader = false;
          }
        })
        .catch((err) => {
          self.loader = false;
          console.log("err", err);
        });
    },

    downloadStandardExel() {
      let self = this;
      self.loader = true;
      let payload = {
        extract_date: moment(self.dateRangeBestSeller.startDate).format(
          "YYYY-MM-DD"
        ),
        category: self.selectedSubCategory.key,
        price_range: self.selectedPriceBand.value,
        plateform: self.selectedPlatform.key,
      };
      let url = "/api/v2/export/bestsellersranks";
      self.$http
        .post(url, payload)
        .then((response) => {
          window.location = response.body.data;
          self.loader = false;
        })
        .catch((err) => {
          console.log(err);
          self.loader = false;
        });
    },
    processBestSellerRankTableData() {
      if ($.fn.DataTable.isDataTable("#bestSellerRankTable")) {
        $("#bestSellerRankTable").DataTable().clear().destroy();
      }
      // $("#bestSellerRankTable").dataTable();
      this.$nextTick(() => {
        $("#bestSellerRankTable").DataTable({
          autoWidth: false,
          language: {
            search: "",
            paginate: {
              first: "",
              previous: "<",
              next: ">",
              last: "",
            },
            lengthMenu: "<h5>Show entries</h5> _MENU_",
          },
          pagingType: "full_numbers",
        });
        let search = require("../../../public/Icons_SVG/Search.svg");
        $("#bestSellerRankTable_filter > label > input").attr(
          "placeholder",
          "Search"
        );
        $("#bestSellerRankTable_filter > label").append(
          `<div><img src='${search}' width='17'/></div>`
        );
        $("#bestSellerRankTable_length > label > select").removeClass();

        var btn = $(
          '<input type="button" class="btn downloadBtn" value="Export" id="downloadBtn"/>'
        );
        $("#bestSellerRankTable_filter > label").append(btn);
        $("#downloadBtn").click(() => {
          this.downloadStandardExel();
        });
      });
    },

    getBestSellerRankData(applyFilter) {
      let self = this;
      self.viewBestSellersRankTableBodyData = "";
      self.viewBestSellersRankTableHeaderData = "";
      self.bestSellerMainTableShowData = false;
      self.loader = true;
      let payload = {
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      let url = "/api/v2/bestsellersranks";
      if (applyFilter) {
        (payload.extract_date = moment(
          self.dateRangeBestSeller.startDate
        ).format("YYYY-MM-DD")),
          (payload.category = this.selectedSubCategory.key),
          (payload.price_range = this.selectedPriceBand.value);
        payload.plateform = this.selectedPlatform.key;
        if ($.fn.DataTable.isDataTable("#bestSellerRankTable")) {
          $("#bestSellerRankTable").DataTable().clear().destroy(); // Properly clear and destroy
        }
      }

      self.$http
        .post(url, payload)
        .then((response) => {
          self.viewBestSellersRankTableHeaderData = response.data.data.header;
          self.viewBestSellersRankTableBodyData =
            response.data.data.sellerRankData;
          self.bestSellerMainTableShowData = response.data.data_present;
          if (!applyFilter) {
            self.bestSellerLastUpdatedDataDate = moment(
              response.data.data.updated_dates.last_updated
            ).format("DD MMM, YYYY");
            self.dateRangeBestSeller.startDate = moment(
              response.data.data.updated_dates.last_updated
            ).format("YYYY-MM-DD");
            self.dateRangeBestSeller.endDate = moment(
              response.data.data.updated_dates.last_updated
            ).format("YYYY-MM-DD");
            this.dateRange.endDate = moment(
              response.data.data.updated_dates.last_updated
            ).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(
              response.data.data.updated_dates.last_updated
            )
              .subtract(1, "week")
              .format("YYYY-MM-DD");

            this.lastUpdated = moment(
              response.data.data.updated_dates.last_updated
            ).format("DD MMM, YYYY");
            this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
            this.maxDate = new Date(response.data.data.updated_dates.end_date);
            this.minDate = new Date(
              response.data.data.updated_dates.start_date
            );
            self.bestSellerMinDate = new Date(
              response.data.data.updated_dates.start_date
            );
            self.bestSellerMaxDate = new Date(
              response.data.data.updated_dates.end_date
            );
            self.viewBestSellersRankFiltereData =
              response.data.data.filters_new;
            self.viewBestSellersRankFiltereDataForPrice =
              response.data.data.filters;
            self.selectedPlatform =
              response.data.data.selected_category_new.plateform;
            self.selectedCategory =
              response.data.data.selected_category_new.sub_category1;
            self.selectedSubCategory =
              response.data.data.selected_category_new.sub_category2;
            if (response.data.data.selected_category.price === "") {
              self.selectedPriceBand = { label: "All", value: "" };
            } else {
              self.selectedPriceBand = {
                label: response.data.data.selected_category.price,
                value: response.data.data.selected_category.price,
              };
            }
            this.processBestSellerFilter(false);
            this.getWebsiteandKeywordDropdownData();
            // this.getAllStatusByApi()
          }
          this.$nextTick(() => {
            self.processBestSellerRankTableData();
            self.loader = false;
          });
        })
        .catch((err) => {
          self.loader = false;
          console.log("err");
          self.bestSellerMainTableShowData = false;
        });
    },

    getAllStatusByApi() {
      let self = this;
      self.loaderTableStatus = true;
      const url = "api/v2/sensespiderstatus";
      let payload = {
        // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
        timestamp: moment(this.dateRangeBestSeller.endDate).format(
          "YYYY-MM-DD"
        ),
        feature: "pincode",
        
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          self.storeAllDataForBestSellerTableStatus = response.body.data;
          if (Object.keys(self.storeAllDataForBestSellerTableStatus).length) {
            self.storeBestSellerTableStatus =
              self.storeAllDataForBestSellerTableStatus[
                self.selectedPlatform.key.toLowerCase().replace(" ", "_")
              ][self.selectedSubCategory.key.replace("-", "_")];
          } else {
            self.storeBestSellerTableStatus = "";
          }
          self.loaderTableStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderTableStatus = false;
        });
    },

    submitDetails() {
      let self = this;
      self.loader = true;
      this.sellerGraphLineShowData = false;
      self.sellerGraph.data = [];
      let payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        link: self.selectedlink.link,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/adword/amazon_seller_link_graph";
      self.$http
        .post(url, payload)
        .then((response) => {
          // console.log(response.data.data_present, 'key')
          if (Object.keys(response.data.data).length) {
            self.sellerGraph.data = response.data.data.data;
          }
          self.processCategoryListData();
          self.loader = false;
          this.sellerGraphLineShowData = response.data.data_present;
        })
        .catch((err) => {
          self.loader = false;
          this.sellerGraphLineShowData = false;
          console.log("err");
        });
    },

    processBestSellerFilter(applyFilter) {
      this.viewPlatformList = [];
      //   Object.entries(this.viewBestSellersRankFiltereData).forEach(([key, value]) => {
      //     this.viewPlatformList.push(key)
      //   })
      this.viewPlatformList = this.viewBestSellersRankFiltereData.platform;
      if (applyFilter) this.selectedPlatform = this.viewPlatformList[0];
      this.filterCategoryData(applyFilter);
    },

    filterCategoryData(applyFilter) {
      if (Object.keys(this.storeAllDataForBestSellerTableStatus).length) {
        this.storeBestSellerTableStatus =
          this.storeAllDataForBestSellerTableStatus[
            this.selectedPlatform.key.toLowerCase().replace(" ", "_")
          ][this.selectedSubCategory.key.replace("-", "_")];
      } else {
        this.storeBestSellerTableStatus = "";
      }
      this.viewCategoryList = [];
      this.viewCategoryList = this.viewBestSellersRankFiltereData.sub_category1;
      //   Object.entries(this.viewBestSellersRankFiltereData[this.selectedPlatform]).forEach(([key, value]) => {
      //     this.viewCategoryList.push(key)
      //   })
      if (applyFilter) this.selectedCategory = this.viewCategoryList[0];
      this.filterSubCategoryData(applyFilter);
    },

    filterSubCategoryData(applyFilter) {
      this.viewSubCategoryList = [];
      //   Object.entries(this.viewBestSellersRankFiltereData[this.selectedPlatform][this.selectedCategory]).forEach(([key, value]) => {
      //     this.viewSubCategoryList.push(key)
      //   })
      this.viewSubCategoryList =
        this.viewBestSellersRankFiltereData.sub_category2;
      if (applyFilter) this.selectedSubCategory = this.viewSubCategoryList[0];
      this.filterPriceBandData(applyFilter);
    },

    filterPriceBandData(applyFilter) {
      this.viewPriceBandList = [];
      Object.entries(
        this.viewBestSellersRankFiltereDataForPrice[this.selectedPlatform.key][
          this.selectedCategory.key
        ][this.selectedSubCategory.key]
      ).forEach(([key, value]) => {
        this.viewPriceBandList.push(value);
      });
      if (applyFilter) this.selectedPriceBand = { label: "All", value: "" };
    },

    processCategoryListData() {
      let self = this;
      let amazonSellerData = self.sellerGraph.data;
      let temp = [];
      for (let d of amazonSellerData) {
        if (!temp.includes(d)) temp.push(d.category);
      }
      self.sellerGraph.CategoryList = temp;
      self.sellerGraph.selectedCategory = self.sellerGraph.CategoryList[0];
      self.processSellerGraphData();
    },

    processSellerGraphData() {
      let self = this;
      self.loader = true;
      let amazonSellerData = self.sellerGraph.data;
      let seriesData = [
        {
          name: "",
          data: [],
          color: "#47A694",
        },
      ];

      let xaxis = [];
      for (let d of amazonSellerData) {
        if (d.category == self.sellerGraph.selectedCategory) {
          seriesData[0].name = self.sellerGraph.selectedCategory;
          for (const d2 of d.data) {
            xaxis.push(moment(d2.timestamp).format("DD MMM YYYY"));
            seriesData[0].data.push(d2.rank);
          }
          self.lineChart(xaxis, seriesData);
          self.loader = false;
          return false;
        }
      }
    },

    lineChart(xaxis, seriesData) {
      this.lineChartData = {
        chart: {
          type: "line",
          height: 250,
        },
        lang: {
          thousandsSep: "",
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },

        xAxis: {
          categories: xaxis,
          tickmarkPlacement: "on",
          crosshair: true,
          crosshair: {
            width: 70,
          },
          labels: {
            y: 32,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
        },

        yAxis: {
          min: 0,
          title: {
            enabled: false,
          },
          labels: {
            x: -23,
            style: {
              color: "#a1a1a1",
              fontFamily: "Heebo",
              fontWeight: 400,
              fontSize: "14px",
              // letterSpacing: '1px',
            },
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#a1a1a1",
            fontSize: "14px",
            letterSpacing: "1px",
            textTransform: "capitalize",
          },
        },
        tooltip: {
          formatter: function () {
            return this.x + " : <b>" + this.y.toLocaleString("en-US") + "</b>";
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              symbol: "circle",
            },
          },
        },
        series: seriesData,
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.capitalize {
  text-transform: capitalize;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox {
  height: 30px;
  border: 1px solid silver;
  display: flex;
  justify-content: start;
  background: white;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.falseIcon {
  color: #ff0000 !important;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid silver;
  padding: 10px;
}

.productImg {
  width: 6vw;
}

.product-title {
  font-size: 22px;
}

.productImg img {
  width: 100%;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

select {
  font-family: "Poppins", sans-serif;
}

select {
  border-radius: 5px !important;
}

select option {
  text-transform: capitalize;
  padding: 10px 0px;
}

/* .noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
} */

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

.product-name-column {
  width: 32% !important;
}

.brand-width-column {
  width: 6% !important;
}

.seller-width-column {
  width: 22% !important;
}

.rank-width-column {
  width: 5% !important;
}

.rating-width-column {
  width: 6% !important;
}

.originalPrice-width-column {
  width: 11%;
}

.review-width-column {
  width: 7%;
}

.discountPrice-width-column {
  width: 11%;
}
</style>
<style>
#bestSellerRankTable_filter > label,
#rankWiseBestSellerRankTable_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#bestSellerRankTable_filter input,
#rankWiseBestSellerRankTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#bestSellerRankTable_filter input:focus,
#rankWiseBestSellerRankTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#bestSellerRankTable_filter input::placeholder,
#rankWiseBestSellerRankTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable_filter input:-ms-input-placeholder,
#rankWiseBestSellerRankTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable_filter input::-ms-input-placeholder,
#rankWiseBestSellerRankTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable,
#rankWiseBestSellerRankTable {
  table-layout: fixed;
  width: 100%;
}

#bestSellerRankTable .page-item:focus,
#rankWiseBestSellerRankTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#bestSellerRankTable_filter div,
#rankWiseBestSellerRankTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#bestSellerRankTable_filter img,
#rankWiseBestSellerRankTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#bestSellerRankTable_paginate,
#rankWiseBestSellerRankTable_paginate {
  position: relative;
  top: 2px;
  z-index: 100;
  float: right;
  /* width: 50vw; */
}

#bestSellerRankTable_info,
#rankWiseBestSellerRankTable_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  z-index: 100;
  /* float: right; */
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#bestSellerRankTable_length label,
#rankWiseBestSellerRankTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#bestSellerRankTable_length h5,
#rankWiseBestSellerRankTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#bestSellerRankTable_length select,
#bestSellerRankTableRankTableRankWise_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#bestSellerRankTable_paginate .page-link,
#rankWiseBestSellerRankTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#bestSellerRankTable_filter .downloadBtn,
#rankWiseBestSellerRankTable_filter .downloadBtn {
  margin: 0px 10px;
  height: 35px;
  width: 80px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#bestSellerRankTable_filter .downloadBtn:hover,
#rankWiseBestSellerRankTable_filter .downloadBtn:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

#bestSellerRankTable_paginate ul.pagination li.active,
#rankWiseBestSellerRankTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#bestSellerRankTable,
#rankWiseBestSellerRankTable {
  border-radius: 20px 20px 0 0 !important;
}

#bestSellerRankTable .thead-normal,
#bestSellerRankTable .thead-normal tr:first-child,
#bestSellerRankTable .thead-normal > tr:first-child > th:first-child,
#rankWiseBestSellerRankTable .thead-normal,
#rankWiseBestSellerRankTable .thead-normal tr:first-child,
#rankWiseBestSellerRankTable .thead-normal > tr:first-child > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0 !important;
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal > tr:last-child > th:first-child,
#rankWiseBestSellerRankTable .thead-normal > tr:last-child > th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal > tr:first-child > th:last-child,
#rankWiseBestSellerRankTable .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#bestSellerRankTable .thead-normal > tr:first-child > th,
#rankWiseBestSellerRankTable .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 400 !important;
  text-align: center !important;
  padding: 5px 25px 0px 25px !important;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal > tr:last-child > th,
#rankWiseBestSellerRankTable .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 400 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal > tr > th.sorting:before,
#rankWiseBestSellerRankTable .thead-normal > tr > th.sorting:before {
  font-size: 12px;
  bottom: 60%;
  color: var(--base_color-80);
}

#bestSellerRankTable .thead-normal > tr > th.sorting:after,
#rankWiseBestSellerRankTable .thead-normal > tr > th.sorting:after {
  font-size: 12px;
  top: 50%;
  color: var(--base_color-80);
}

#bestSellerRankTable th select,
#rankWiseBestSellerRankTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#bestSellerRankTable th,
#rankWiseBestSellerRankTable th {
  font-family: "poppins" !important;
  font-size: 14px !important;
  color: #5e5e5e !important;
  font-weight: 600 !important;
}

#bestSellerRankTable tfoot th,
#rankWiseBestSellerRankTable tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#bestSellerRankTable tfoot th:first-child,
#rankWiseBestSellerRankTable tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#bestSellerRankTable tbody td,
#rankWiseBestSellerRankTable tbody td {
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
  color: #5e5e5e !important;
  font-weight: 400 !important;
}

#bestSellerRankTable tbody td:first-child,
#rankWiseBestSellerRankTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .even td,
#rankWiseBestSellerRankTable .even td {
  background: #fff !important;
}

#bestSellerRankTable .odd td,
#rankWiseBestSellerRankTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #bestSellerRankTable_wrapper .bottom {
  margin: -30px;
} */
#bestSellerRankTable_wrapper > .row:last-child {
  margin-bottom: 15px;
}

#bestSellerRankTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

.form-control {
  font-size: 12px !important;
}

#bestSellerRankTable tbody td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

#bestSellerRankTable tbody td.product-name-column {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>
